import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../api/auth";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
  });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await registerUser(formData);

      // ✅ Check Laravel response
       if (res.data && res.data.success === true) {
        setMessage(res.data.message || "Registration successful!");
        // ✅ Redirect after 1.5 sec
        setTimeout(() => {
        navigate("/login");
      }, 1500);
      } else {
        setMessage(res.data.message || "Registration failed. Please try again.");
      }
    } catch (err) {
      console.error("Registration Error:", err);

      // ✅ Show Laravel validation errors
      if (err.response && err.response.data) {
        const errorData = err.response.data;
        if (errorData.errors) {
          const errorMessages = Object.values(errorData.errors)
            .flat()
            .join(" ");
          setMessage(errorMessages);
        } else if (errorData.message) {
          setMessage(errorData.message);
        } else {
          setMessage("Registration failed. Please try again.");
        }
      } else {
        setMessage("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Register</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password_confirmation"
            placeholder="Confirm Password"
            value={formData.password_confirmation}
            onChange={handleChange}
            required
          />
          <button type="submit">Register</button>
        </form>

        {message && (
          <p
            className={
              message.toLowerCase().includes("success")
                ? "success"
                : "error"
            }
          >
            {message}
          </p>
        )}

        <p>
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            style={{ color: "#007bff", cursor: "pointer" }}
          >
            Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default Register;
